import { findLocationByPlaceId } from './geoLocator';
import { AutocompletePredictionRestrictionTypes } from './types';
import { createAutocompletionRequest, getAutoCompleteService } from './api/placePredictions';
import { CANADA_COUNTRY_FILTER, US_AND_CANADA_COUNTRY_FILTER } from './googleSearchPredictions';
import { CountryCode, CountryCodeList } from 'types/countries';

export async function getPositionFromDescription(areaName: string, useUsListings = false) {
  const placeIds = await querySinglePosition(areaName, useUsListings ? US_AND_CANADA_COUNTRY_FILTER : CANADA_COUNTRY_FILTER);
  return await findLocationByPlaceId(placeIds[0]?.place_id);
}

async function querySinglePosition(
  input: string,
  country: readonly CountryCode[] = US_AND_CANADA_COUNTRY_FILTER
) {
  const autocompleteService = await getAutoCompleteService();

  if (autocompleteService) {
    const inputUpper = input.toUpperCase();
    if ((/USA$|US$|, USA|, US/).test(inputUpper) && !country.includes(CountryCodeList.UNITED_STATES)) {
      // added a condition to forcibly ignore the header being set to Canada when a US location is entered without interfering with other functions
      country = US_AND_CANADA_COUNTRY_FILTER;
    }

    // Try point_of_interest first - for military base search
    const request = await createAutocompletionRequest(input, AutocompletePredictionRestrictionTypes.POINT_OF_INTEREST, country);
    const response = await autocompleteService.getPlacePredictions(request);

    if (response?.predictions && response.predictions.length > 0) {
      return response.predictions;
    }

    // If no results, fall back to geocode
    const fallbackRequest = await createAutocompletionRequest(input, AutocompletePredictionRestrictionTypes.GEOCODE, country);
    const fallbackResponse = await autocompleteService.getPlacePredictions(fallbackRequest);

    if (fallbackResponse?.predictions) {
      return fallbackResponse.predictions;
    }
  }
  throw new Error('AutocompleteService could not be created.');
}
